import React from 'react';
import { useParams } from 'react-router-dom';
import { Card } from '@perch-labs/shrike';
import { copyFor, routes } from 'config';
import { Container } from 'styles';
import { ErrorModule } from 'components/errors';
import { LoadingModule } from 'components/loading';
import { StandardRow } from 'components/standard-row';
import { BillingStatusData } from 'hooks/use-billing-status.hook';
import { MAX_DISPLAY_STATEMENTS } from 'domain/statement';
import { StatementRow } from '../statement-row';

const getCopy = copyFor('billing.dashboard.billingHistory');
interface Props {
  error?: any;
  loading?: boolean;
  statements: BillingStatusData['issuedStatements'];
}
export const BillHistory = ({ statements, error, loading }: Props) => {
  const { planId } = useParams<{ planId?: string }>();
  if (loading) return <LoadingModule />;
  if (error || !statements) return <ErrorModule title={getCopy('title')} />;
  const statementsToDisplay = statements.slice(0, MAX_DISPLAY_STATEMENTS);
  const hasMoreStatements = statements.length > MAX_DISPLAY_STATEMENTS;

  return (
    <Card mobileVariant="flat">
      <Card.Header title={getCopy('title')} />
      <Container padding="16px 0 40px" small={{ padding: '16px 0 40px 24px' }}>
        {statementsToDisplay.map(statement => (
          <StatementRow
            includesBuffer={true}
            statement={statement}
            key={`bill-history-id-${statement.id}`}
          />
        ))}
        {hasMoreStatements && (
          <StandardRow
            mobileBufferWidth="0px"
            bufferWidth="32px"
            includesBuffer={true}
            iconLinkProps={{
              ariaLabel: getCopy('links.viewAll'),
              to: routes({ planId }).statements,
            }}
            heading={getCopy('links.viewAll')}
          />
        )}
      </Container>
    </Card>
  );
};
